import { render, staticRenderFns } from "./TextPreview.vue?vue&type=template&id=2e3f3d56&scoped=true&functional=true&"
import script from "./TextPreview.vue?vue&type=script&lang=js&"
export * from "./TextPreview.vue?vue&type=script&lang=js&"
import style0 from "./TextPreview.vue?vue&type=style&index=0&id=2e3f3d56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2e3f3d56",
  null
  
)

export default component.exports